import config from "../config";
import { MenuDto } from "src/types/base";
import { ResponseDto } from "../dtos/common/responseDto";
import { UserResponseDto } from "../dtos/user/response/userResponseDto";
import { UserSimpleResponseDto } from "../dtos/user/response/userSimpleResponseDto";
import { getData, patchData } from "../utils/axios/serverHelper";
import { BookmarkCdList } from "src/store/useCommonCodeStore";
import { encryptPassword } from "../utils/auth/passwordEncrypt";

const baseUrl = `${config.apiUrl}/user`;

// 사원정보 검색 모달
export const getUserBySearch = async (keyword: string) => {
    const url = `${baseUrl}`

    return await getData<ResponseDto<UserSimpleResponseDto[]>>(url, {
        params: { keyword }  
    });
}

// 사원정보 조회
export const getUserDetail = async (empNo: string) => {
    const url = `${baseUrl}/info`
    return await getData<ResponseDto<UserSimpleResponseDto>>(url, {
        params: { empNo }
    });
}

// 내 정보 조회
export const getMyInfo = async () => {
    const url = `${baseUrl}/me`;
    return await getData<ResponseDto<UserResponseDto>>(url);
}


// 비밀번호 변경
export const changeMyPassword = async (currentPassword: string, newPassword: string) => {
	const url = `${baseUrl}/password`;

	return await patchData<{ currentPassword: string; newPassword: string }, ResponseDto<any>>(url, {
		currentPassword: encryptPassword(currentPassword),
		newPassword: encryptPassword(newPassword)
	});
}
